export default "__VITE_ASSET__BTSk1Tge__"